import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { SoakingRequestDTO } from "./soaking-request.dto";

export class SoakingTubResponseModel extends GlobalResponseObject{
    data?: SoakingRequestDTO;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data string
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SoakingRequestDTO) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}